import type React from "react";
import { useState } from "react";
import { cn } from "@/core/shared/v2/lib/utils";

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholder?: string;
  width?: number;
  height?: number;
}

export const LazyImage = ({ src, placeholder, className, alt, width, height, ...props }: LazyImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div
      className={cn("relative shrink-0 overflow-hidden", className)}
      style={
        width && height && !className?.includes("w-") && !className?.includes("h-") ? { width, height } : undefined
      }
    >
      {placeholder && (
        <img
          src={placeholder}
          alt=""
          aria-hidden="true"
          className={cn(
            "absolute inset-0 h-full w-full object-cover transition-opacity duration-500",
            isLoaded ? "opacity-0" : "opacity-100",
          )}
        />
      )}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
        className={cn(
          "h-full w-full object-cover transition-opacity duration-500",
          isLoaded ? "opacity-100" : "opacity-0",
        )}
        {...props}
      />
    </div>
  );
};
